/* src/auth/LoginScreen.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { get, upperFirst, toUpper } from 'lodash';

import Storage from '../../util/storage';

import {
  Button,
  Card,
  CircularProgress,
  Snackbar,
  SnackbarContent,
  TextField,
  Typography,
} from '@material-ui/core';
import { Content } from '../../app/components';
import { loadTexts } from '../../config/texts';
import { validateEmail } from '../../util/strings';
import {
  validateToken,
  login,
  login2fa,
  verify2fa,
  fetchUser,
  forgotPassword,
} from './actions';

const TEXT_KEY = 'login';

class LoginScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      forgotPassword: false,
      token2fa: '',
      code2fa: '',
      message: '',
      loading: false,
      texts: loadTexts(TEXT_KEY, props.locale),
    };

    this.messages = (error, type, forgotPassword) => {
      let text = '';
      let color = 'secondary';
      if (error.code) {
        if (forgotPassword) text = this.state.texts.error.forgotPassword;
        else text = this.state.texts.error.other;

        return { text, color };
      }

      switch (type) {
        case 'email_invalid':
          text = this.state.texts.error.invalid_format;
          break;
        case 'forgot_password_success':
          text = this.state.texts.error.email_sent;
          color = 'textPrimary';
          break;
        case 'invalid_2fa':
          text = this.state.texts.error.invalid_2fa;
          break;
        default:
      }
      return { text, color };
    };

    this._onChangeText = this._onChangeText.bind(this);
    this._sendEmailPassword = this._sendEmailPassword.bind(this);
    this._verify2fa = this._verify2fa.bind(this);
    this._onResend2fa = this._onResend2fa.bind(this);
  }

  async componentDidMount() {
    // autologin
    /*
    const token = await Storage.getToken();
    if (token) {
      this.setState({ loading: true });
      try {
        await this.props.validateToken({ token });
        if (this.props.token) {
          this.props.clearError();
          await this.props.fetchUser();
          if (get(this, 'props.user._id'))
            this.props.history.push('/home');
        }
      } finally {
        this.setState({ loading: false });
      }
    }
    */
  }

  _onClickForgotPassword = () => {
    this.setState(state => ({
      forgotPassword: !state.forgotPassword,
      message: '',
    }));
  };

  _onChangeText(field) {
    return event => {
      this.setState({ [field]: event.target.value });
    };
  }

  async _verify2fa() {
    if (!this.state.token2fa) {
      return;
    }

    try {
      const result = await this.props.verify2fa({
        token: this.state.token2fa,
        code: this.state.code2fa,
      });
      this.props.clearError();

      const message = get(result, 'payload.message', '');
      if (typeof message === 'string' && message.includes('error')) {
        this.setState({
          message: 'invalid_2fa',
          forgotPassword: false,
        });
      }

      if (this.props.token) {
        await this.props.fetchUser();
        if (get(this, 'props.user._id')) this.props.history.push('/home');
      }
    } catch (error) {
      this.setState({
        message: 'invalid_2fa',
        forgotPassword: false,
      });
    }
  }

  async _onResend2fa() {
    const { email, password } = this.state;
    const loginResult = await this.propsp.login2fa({ email, password });
    const token2fa = get(loginResult, 'payload.login.twoFactorToken');
    if (token2fa) {
      this.setState({ token2fa });
    }
  }

  async _sendEmailPassword() {
    const { email, password, forgotPassword } = this.state;

    if (!validateEmail(email)) {
      this.setState({ message: 'email_invalid' });
      return;
    }
    this.setState({ message: '' });
    this.props.clearError();

    if (!forgotPassword) {
      /*
      const loginResult = await this.props.login2fa({ email, password });
      const token2fa = get(loginResult, 'payload.login.twoFactorToken');
      if (token2fa) {
        this.props.clearError();
        //global.__token_nim = null;
        //Storage.setToken(this.props.token);
        this.setState({ token2fa });
      }
      return;
      */
      await this.props.login({ email, password });
      if (this.props.token) {
        this.props.clearError();
      }

      await this.props.fetchUser();
      if (get(this, 'props.user._id')) {
        this.props.history.push('/home');
      }

      return;
    }

    await this.props.forgotPassword({ email });
    if (!this.props.error)
      this.setState({
        message: 'forgot_password_success',
        forgotPassword: false,
      });
  }

  render() {
    const { email, password, forgotPassword, message, texts } = this.state;
    const { classes, error, loading } = this.props;
    const { text: m, color: mColor } = this.messages(
      error,
      message,
      forgotPassword,
    );
    return (
      <Content className={classes.container} open={false}>
        <Card className={classes.card}>
          {!this.state.token2fa && (
            <React.Fragment>
              <div>
                <TextField
                  id="email"
                  label={upperFirst(texts.email)}
                  value={email}
                  onChange={this._onChangeText('email')}
                  margin="normal"
                  fullWidth
                  disabled={this.state.loading}
                />
                {!forgotPassword && (
                  <TextField
                    id="password"
                    label={upperFirst(texts.password)}
                    value={password}
                    onChange={this._onChangeText('password')}
                    margin="normal"
                    type="password"
                    fullWidth
                    disabled={this.state.loading}
                  />
                )}
              </div>
              {m && <Typography color={mColor}>{m}</Typography>}
              <div className={classes.buttonContainer}>
                {(loading || loading) && (
                  <CircularProgress className={classes.progress} />
                )}
                <Button variant="raised" onClick={this._sendEmailPassword}>
                  {forgotPassword
                    ? texts.send_reset_password
                    : toUpper(texts.login)}
                </Button>
              </div>
              <Button
                size="small"
                color="primary"
                onClick={this._onClickForgotPassword}
              >
                {forgotPassword
                  ? texts.remember_password
                  : texts.forgot_password}
              </Button>
            </React.Fragment>
          )}
          {this.state.token2fa && (
            <React.Fragment>
              <Typography className={classes.message2fa}>
                {`${texts.message_2fa} ${this.state.email}`}
              </Typography>
              <TextField
                id="code2fa"
                label={texts.code2fa}
                value={this.state.code2fa}
                onChange={this._onChangeText('code2fa')}
                margin="normal"
                fullWidth
              />
              {m && <Typography color={mColor}>{m}</Typography>}
              <Button size="small" color="primary" onClick={this._onResend2fa}>
                {texts.resend}
              </Button>
              <div className={classes.buttonContainer}>
                <Button
                  size="small"
                  color="secondary"
                  onClick={() => this.setState({ code2fa: '', token2fa: '' })}
                >
                  {texts.cancel}
                </Button>
                <Button
                  disabled={!Boolean(this.state.code2fa)}
                  size="small"
                  variant="raised"
                  onClick={this._verify2fa}
                >
                  {texts.login}
                </Button>
              </div>
            </React.Fragment>
          )}
        </Card>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open>
          <SnackbarContent
            className={classes.alert}
            message={
              <span className={classes.message}>
                <a href="https://console.nimbuslearning.com">
                  {texts.alert_message}
                </a>
              </span>
            }
          />
        </Snackbar>
      </Content>
    );
  }
}

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  card: {
    width: 300,
    padding: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  link: {
    textDecoration: 'none',
  },
  progress: {
    marginRight: theme.spacing.unit,
  },
  message2fa: {
    marginTop: theme.spacing.unit * 3,
  },
  alert: {
    backgroundColor: theme.palette.background.default,
  },
  message: {
    color: 'black',
  },
});

LoginScreen.propTypes = {
  login: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.object.isRequired,
  error: PropTypes.any.isRequired,
  loading: PropTypes.bool.isRequired,
  token: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const {
    data: { user, token },
    loading,
  } = state.auth;
  const { error, locale } = state.appState;
  return { user, token, loading, error, locale };
};

const mapDispatchToProps = dispatch => ({
  validateToken: params => dispatch(validateToken(params)()),
  login: params => dispatch(login(params)()),
  login2fa: params => dispatch(login2fa(params)()),
  verify2fa: params => dispatch(verify2fa(params)()),
  fetchUser: () => dispatch(fetchUser()()),
  clearError: () => dispatch({ type: 'CLEAR_ERROR' }),
  forgotPassword: params => dispatch(forgotPassword(params)()),
});

export default compose(
  withRouter,
  withStyles(styles, { name: 'LoginScreen' }),
  connect(mapStateToProps, mapDispatchToProps),
)(LoginScreen);



// WEBPACK FOOTER //
// ./src/modules/auth/LoginScreen.js